module.exports = __webpack_public_path__ + "static/img/__4953.390e7cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__4953.jpg
// module id = 19DA
// module chunks = 0